import {
  Authenticator,
  useAuthenticator,
  Flex,
  View,
  Message,
  Button,
  Image,
} from "@aws-amplify/ui-react";
import { Outlet, ScrollRestoration, useNavigate } from "react-router-dom";
import {
  MarketingFooterBrand,
  NavBarHeader,
  NavBarSide,
} from "./ui-components";
import logo from "./components/logos/logo_full.png"; // Tell webpack this JS file uses this image

import { useTour } from "@reactour/tour";
import React, { useEffect, useRef, useState } from "react";
import config from "./bot/config";
import MessageParser from "./bot/MessageParser";
import ActionProvider from "./bot/ActionProvider";
import Chatbot from "react-chatbot-kit";
import { useUserMutation } from "./components/common/useUserMutation";
import { PostProfileMutation } from "./components/profile/api/useProfileMutation";
import NavigationHeader from "./components/common/NavigationHeader";
import NavigationSide from "./components/common/NavigationSide";
import { signUp } from "aws-amplify/auth";
import FooterComponent from "./components/common/FooterComponent";

const RedirectComponent = () => {
  const { mutate: userMutate } = useUserMutation();
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const saveData = PostProfileMutation();
  // const [isChecked, setIsChecked] = useState(false);
  // const [showBot, toggleBot] = useState(false);
  // const { setIsOpen } = useTour();
  const navigate = useNavigate();

  useEffect(() => {
    const signUpValues = JSON.parse(sessionStorage.getItem("tempSingUp"));
    if (signUpValues) {
      saveData.mutate(signUpValues);
      sessionStorage.removeItem("tempSingUp");
    }
    if (user) {
      const advocateSessionValues = JSON.parse(
        sessionStorage.getItem("advocateSession")
      );
      if (advocateSessionValues) {
        userMutate(advocateSessionValues);
      } else {
        userMutate({ patientUserId: user?.userId, isAdvocating: false });
      }
    }
    if (window.location.pathname === "/") {
      navigate("/user/quick-actions/insights");
    }
  }, [user]);

  // useEffect(() => {
  //   setIsOpen(isChecked);
  // }, [isChecked]);

  return (
    <>
      <ScrollRestoration />
      {/* <View>
        {showBot && (
          <div className="app-chatbot-container">
            <Chatbot
              headerText="Get quick health insights"
              config={config}
              messageParser={MessageParser}
              actionProvider={ActionProvider}
            />
          </div>
        )}

        <button
          className="app-chatbot-button"
          onClick={() => toggleBot((prev) => !prev)}
        >
          <div>Bot</div>
          <svg viewBox="0 0 640 512" className="app-chatbot-button-icon">
            <path d="M192,408h64V360H192ZM576,192H544a95.99975,95.99975,0,0,0-96-96H344V24a24,24,0,0,0-48,0V96H192a95.99975,95.99975,0,0,0-96,96H64a47.99987,47.99987,0,0,0-48,48V368a47.99987,47.99987,0,0,0,48,48H96a95.99975,95.99975,0,0,0,96,96H448a95.99975,95.99975,0,0,0,96-96h32a47.99987,47.99987,0,0,0,48-48V240A47.99987,47.99987,0,0,0,576,192ZM96,368H64V240H96Zm400,48a48.14061,48.14061,0,0,1-48,48H192a48.14061,48.14061,0,0,1-48-48V192a47.99987,47.99987,0,0,1,48-48H448a47.99987,47.99987,0,0,1,48,48Zm80-48H544V240h32ZM240,208a48,48,0,1,0,48,48A47.99612,47.99612,0,0,0,240,208Zm160,0a48,48,0,1,0,48,48A47.99612,47.99612,0,0,0,400,208ZM384,408h64V360H384Zm-96,0h64V360H288Z"></path>
          </svg>
        </button>
      </View> */}

      <Flex direction="row">
        <Message
          grow={1}
          variation="filled"
          colorTheme="success"
          heading="Please give us feedback!"
          isDismissible={true}
        >
          Your feedback is so valuable for us! Click on the button below to fill
          out a quick survey!
          <Flex>
            <Button
              onClick={() =>
                window.open(
                  "https://docs.google.com/forms/d/e/1FAIpQLSeeN0nKPQYIDpdnk2zK-pVIYqQzWicKQY6U1HUrjZsDeAAonQ/viewform?usp=sf_link"
                )
              }
            >
              Take me to Survey
            </Button>
          </Flex>
        </Message>
      </Flex>
      <Flex direction="row">
        <NavigationHeader />
      </Flex>
      <Flex direction="row">
        <View display={{base:'none', large:'block'}} padding={21}>
          <NavigationSide />
        </View>
        <View flex={1}>
          <div>
            <Outlet />
          </div>
        </View>
      </Flex>
      <Flex direction="column">
        <FooterComponent />
      </Flex>
    </>
  );
};

export default function LogIn() {
  const { route } = useAuthenticator((context) => [
    context.route,
    context.user,
  ]);

  const services = {
    async handleSignUp(input) {
      const { username, password } = input;

      const response = await signUp({
        username: username,
        password,
        options: {
          ...input.options,
          userAttributes: {
            ...input.options?.userAttributes,
          },
        },
      });
      sessionStorage.setItem(
        "tempSingUp",
        JSON.stringify({
          patientUserId: response.userId,
          username: username,
          givenName: input.options?.userAttributes?.given_name,
          primaryPhone: input.options?.userAttributes?.phone_number,
          dob: input.options?.userAttributes?.birthdate,
        })
      );

      return response;
    },
  };

  return (
    <>
      {route === "configuring" && "Loading..."}
      {route !== "authenticated" ? (
        <View minHeight={"100vh"} display={"flex"}>
          <Flex
            direction={{ base: "column" }}
            justifyContent={"center"}
            alignItems={"center"}
            grow={1}
          >
            {/* <img className="App-logo" src={logo} alt="Logo" /> */}
            <Image
              alt="Logo"
              src={logo}
              objectFit="initial"
              objectPosition="50% 50%"
              backgroundColor="initial"
              height={{ base: "33vmin" }}
              // width="75%"
            />
            <Authenticator services={services} loginMechanisms={["username"]} />
          </Flex>
        </View>
      ) : (
        <RedirectComponent />
      )}
    </>
  );
}
